const types = {
  SINGLE_IMAGE_UPLOAD_START: "SINGLE_IMAGE_UPLOAD_START",
  SINGLE_IMAGE_UPLOAD_SUCCESS: "SINGLE_IMAGE_UPLOAD_SUCCESS",
  SINGLE_IMAGE_UPLOAD_ERROR: "SINGLE_IMAGE_UPLOAD_ERROR",
  SINGLE_IMAGE_UPLOAD_STATE_RESET: "SINGLE_IMAGE_UPLOAD_STATE_RESET",
};

export default types;
